// extracted by mini-css-extract-plugin
export default {"form":"styles_form__bpUzR","editor":"styles_editor__QLlQo"};